import React from 'react';
import { Button } from '@material-ui/core';
import { components, colors, fonts, copy } from '@peachjar/components';

import WhiteSpaceSvgWrapper from "../../../components/WhiteSpaceSvgWrapper";
import UhOhTurtle from "../../../components/UhOhTurtle.svg";

const { quotes } = copy;
const { FullSpread, ContentColumn, WhitespaceColumn } = components;
const { prussian } = colors;
const { ProximaNova } = fonts;



let styles = {};

const TempEmailTokenVerificationError = () => (
  <FullSpread>
    <ContentColumn>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          maxWidth: "420px"
        }}
      >
        <h1 style={styles.header}>Uh oh!</h1>
        <p style={{ color: prussian, fontSize: "16px", marginTop: "8px" }}>
          The link you tried to use is expired. Please resend the verification
          email to receive a new one.
        </p>
        <Button className="resend-email-button">
          Resend Verification Email
        </Button>
      </div>
    </ContentColumn>
    <WhitespaceColumn>
      <WhiteSpaceSvgWrapper
        svg={<UhOhTurtle />}
        quote={quotes.franklin_involveMe}
      />
    </WhitespaceColumn>
  </FullSpread>
);

styles = {
  header: {
    fontSize: '34px',
    fontFamily: ProximaNova,
    fontWeight: 500,
    color: prussian,
    maxWidth: '420px',
    marginBottom: '16px',
  },
  resendText: {
    fontSize: '13px',
    fontFamily: ProximaNova,
    color: prussian,
    marginTop: 0,
    marginBottom: 0,
    marginRight: '1rem',
    marginLeft: '1rem',
  },
  resendBox: {
    height: '69px',
    width: '391px',
    backgroundColor: '#f5f5f5',
    padding: '1rem',
    display: 'flex',
    alignItems: 'center',
    marginTop: '32px',
  },
};

export default TempEmailTokenVerificationError;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/TempEmailTokenVerificationError.jsx